export const texts = {
  skill: { de: 'Skill', en: 'Skill' },
  industry: { de: 'Branche', en: 'Industry' },
  degree: { de: 'Abschluss', en: 'Degree' },
  language: { de: 'Sprache', en: 'Language' },
  experience: { de: 'Berufserfahrung', en: 'Work experience' },
  custom: { de: 'Sonstiges', en: 'Other' }
};
